export enum TypeDocumentCodeEnum {
  ATPV,
  ExitATPV,
  CRLV,
  SecurityCode,
  EntryTerm,
  ExitTerm,
  ExitATPVZeroKm,
}
